import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stPoolRewardClaims } from '../../../services/socialTradingService';
import { toRewardClaimFilter } from './helpers';

const RESOURCE = Resources.socialTradingPoolRewardClaims;

export const poolRewardClaimsDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const res = await stPoolRewardClaims({
      ...toRewardClaimFilter(params.filter),
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      // Rows carry no `id`; a contribution is unique per row.
      data: items.map((row) => ({ ...row, id: row.contributionId })),
      total: res?.total ?? items.length,
    };
  },
};
